import { IApplicationState } from '../../types/redux';

export function getHouses({ newbuilding: { housesByName } }: IApplicationState) {
  if (!housesByName) {
    return [];
  }

  return housesByName.filter(house => !!house.fromDeveloperPropsCount);
}
